import {get} from 'lodash';

export default (
  state = {},
  {
    userId,
    frontlineQualifyingVolume,
    gen0Volume,
    totalGenerationVolume,
    clients,
    coaches,
    teams,
    allOrgClientsWithExpiringWellnessCreditsCount,
    allOrgClientsWithExpiringRewardsCount,
    frontlineClientsWithExpiringWellnessCreditsCount,
    frontlineClientsWithExpiringRewardsCount,
  }: any,
) => {
  return {
    ...state,
    homeMetrics: {
      ...get(state, 'homeMetrics', {}),
      [userId]: {
        frontlineQualifyingVolume,
        gen0Volume,
        totalGenerationVolume,
        clients,
        coaches,
        teams,
        allOrgClientsWithExpiringWellnessCreditsCount,
        allOrgClientsWithExpiringRewardsCount,
        frontlineClientsWithExpiringWellnessCreditsCount,
        frontlineClientsWithExpiringRewardsCount,
      },
    },
  };
};
